import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { CacheService } from '@nimbus-library/features/cache';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  public constructor(
    private readonly applicationRef: ApplicationRef,
    private readonly swUpdate: SwUpdate,
    private readonly cacheService: CacheService,
  ) {}

  public initialize(): void {
    this.subscribeUpdate();
    this.checkForUpdate();
  }

  private subscribeUpdate(): void {
    const log = 'SwUpdate => VersionUpdates.';
    this.swUpdate.versionUpdates
      .pipe(
        tap((event) => console.log(`${log} Type: ${event.type}.`)),
        filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'),
      )
      .subscribe((event) => {
        console.log(`${log} App version. Current: ${event.currentVersion.hash}. New: ${event.latestVersion.hash}.`);
        this.cacheService.removeAll();
        setTimeout(() => {
          document.location.reload();
        }, 5000);
      });
  }

  private checkForUpdate(): void {
    const isStable$ = this.applicationRef.isStable.pipe(first((x) => x === true));
    const interval$ = interval(5 * 60 * 1000);
    concat(isStable$, interval$).subscribe(async () => {
      const log = 'SwUpdate => Check for update:';
      try {
        const updateFound = await this.swUpdate.checkForUpdate();
        console.log(`${log} ${updateFound ? 'new version found' : 'no new version'}.`);
      } catch (error) {
        console.error(`${log} ${error}`);
      }
    });
  }
}
